import { periods } from "_constants";

const incentiveTypes = ["new", "renewal", "expansion", "renegotiation", "reduction"];

export default (arr) =>
  [...arr].sort((incA, incB) => {
    if (incA.type !== incB.type) {
      return incentiveTypes.indexOf(incA.type) - incentiveTypes.indexOf(incB.type);
    }

    if (incA.term || incB.term) {
      if (incA.term && incB.term) {
        if (incA.term.value === incB.term.value && incA.term.period === incB.term.period) {
          return incA.title.localeCompare(incB.title);
        }

        return (
          incA.term.value / periods[incA.term.period] - incB.term.value / periods[incB.term.period]
        );
      }

      if (incA.term) return -1;

      return 1;
    }

    return incA.title.localeCompare(incB.title);
  });
